var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { generateQueryParamsStr } from "../../utils/apiUtils";
const GET_ORDERS_CFDI_PREVIEW = (orderID) => `api/order/${orderID}/preview/cfdi`;
const GET_SET_CFDI = 'api/cfdi';
export const getList = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'query',
                'storeId',
                'fromDate',
                'toDate',
                'limit',
                'pageNum'
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_CFDI}?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getList CFDI:', error);
            throw error;
        }
    });
};
//todo: remove
//@DEPRECATED USE getCFDIPreview instead
export const getCFDIPreviewByOrderId = function (id) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${GET_ORDERS_CFDI_PREVIEW(id)}`, config);
        }
        catch (error) {
            console.error('Error fetching:', error);
            throw error;
        }
    });
};
export const downloadCFDIPDF = function (id) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${this.apiToken}`,
                    'Content-Type': 'multipart/form-data',
                    'Content-disposition': 'attachment; filename=[file.pdf]',
                },
                params: {
                    responseType: 'arraybuffer'
                }
            };
            return yield this.axiosInstance.get(`${GET_SET_CFDI}/${id}/download/pdf`, config);
        }
        catch (error) {
            console.error('Error fetching downloadCFDIPDF:', error);
            throw error;
        }
    });
};
export const downloadCFDIZIP = function (id) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${this.apiToken}`,
                    'Content-Type': 'multipart/form-data',
                    'Content-disposition': 'attachment; filename=[file.zip]',
                },
                params: {
                    responseType: 'arraybuffer'
                }
            };
            return yield this.axiosInstance.get(`${GET_SET_CFDI}/${id}/download/zip`, config);
        }
        catch (error) {
            console.error('Error fetching downloadCFDIZIP:', error);
            throw error;
        }
    });
};
export const sendCFDIByEmail = function (id) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${GET_SET_CFDI}/${id}/email`, config);
        }
        catch (error) {
            console.error('Error fetching:', error);
            throw error;
        }
    });
};
// THIS IS FOR WHEN MODAL OPENS AND WE WANT TO GET PREVIEW DATA
export const getCFDIPreview = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'ordersID',
                'customer',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_CFDI}/preview?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching:', error);
            throw error;
        }
    });
};
